import React from "react"
import { Button } from "../../components/common/button/Button";

const ValuationNotProcessed = () => {
  const BASE_URL = `${window.location.origin}`

  return (
    <div className="valuationNotProcessed">
      <div className="valuationNotProcessed-container">
        <p className="valuationNotProcessed-heading">Your valuation could not be processed online.</p>
        <p className="valuationNotProcessed-paragraph">
          Sorry, we couldn’t process your request right now, but you can still get a valuation from us.
        </p>
        <p className="valuationNotProcessed-paragraph" style={{
          paddingBottom: "40px"
        }}>
          Contact a dealership near you and get a quick valuation from one of our experts.
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${BASE_URL}/contact-us`} 
        >
          <Button type="button" variant="blue" id="contact-dealership">
            FIND A DEALERSHIP
          </Button>
        </a>
        <a 
          className="valuationNotProcessed-link"
          href={`${BASE_URL}/`} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Go to main site
        </a>
      </div>
    </div>
  );
};

export default ValuationNotProcessed;